import {Component} from '@angular/core';

import {VoiceService} from '../../services/voice/voice.service';
import {WordPlayBtnComponent} from './word-play-btn.component';
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-homonym-word-play-btn',
  template: `
    <a class="listen-btn {{ on ? 'on' : '' }}"
       *ngIf="word && word.wordVoice"
       (click)="playSound($event)"></a>
  `,
  styleUrls: ['./homonym-word-play-btn.component.scss'],
  host: { class: 'option-btn' },
})
export class HomonymWordPlayBtnComponent extends WordPlayBtnComponent {

  constructor(
    protected override voice: VoiceService,
    protected override globalEventSvc: GlobalEventService,

  ) {
    super(voice, globalEventSvc);
  }

}
